import { Google_api_key, lateNightEndTaxyFee, lateNightSatartTaxyFee, priceDateCriteria } from "./Constants"
import axios from 'axios'

export const isSpecialDate = ((date, basePrice = 0) => {

    if (typeof basePrice !== 'number') return
    // eslint-disable-next-line array-callback-return
    Object.values(priceDateCriteria).map(elm => {
        const inputDate = new Date(date)
        const month = String(inputDate.getMonth() + 1).padStart(2, '0')
        const day = String(inputDate.getDate()).padStart(2, '0')
        let result = elm.dates.includes(`${month}-${day}`)
        if (result) {
            basePrice = basePrice * elm.charge
        }
    })
    return basePrice
})

export const getSpecialDayChargePercentage = ((date) => {

    let percentage = 1
    // eslint-disable-next-line array-callback-return
    Object.values(priceDateCriteria).map(elm => {
        const inputDate = new Date(date)
        const month = String(inputDate.getMonth() + 1).padStart(2, '0')
        const day = String(inputDate.getDate()).padStart(2, '0')
        let result = elm.dates.includes(`${month}-${day}`)
        if (result) {
            percentage = elm.charge
        }
    })
    return percentage
})

export function calculateBooking(startTime, duration) {
    // Parse start time
    let [time, modifier] = startTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    // Create start date
    const startDate = new Date();
    startDate.setHours(hours, minutes, 0, 0);

    // Create end date
    const endDate = new Date(startDate.getTime() + duration * 60 * 60 * 1000);

    // Format end time
    let endHours = endDate.getHours();
    let endMinutes = endDate.getMinutes();
    let ampm = endHours >= 12 ? "PM" : "AM";
    endHours = endHours % 12 || 12;
    let formattedEndTime = `${endHours}:${endMinutes.toString().padStart(2, "0")} ${ampm}`;

    // Taxi fee logic
    let taxiFee = 0;
    if (startDate.getHours() >= 0 && startDate.getHours() < 6) {
        taxiFee = lateNightSatartTaxyFee;
    } else if (endDate.getDate() > startDate.getDate()) {
        taxiFee = lateNightEndTaxyFee;
    }

    return {
        endTime: formattedEndTime,
        taxiFee
    };
}


// console.log(calculateBooking("10:30 PM", 3)); // Ends next day → { endTime: "1:30 AM", taxiFee: 15 }
// console.log(calculateBooking("12:15 AM", 2)); // Starts after midnight → { endTime: "2:15 AM", taxiFee: 20 }


export const containsContactInfo = (text) => {
  if (!text || typeof text !== "string") return false;

  const raw = text.trim();

  // 1) Phone detection by digits-only scan
  const digitsOnly = raw.replace(/\D/g, ""); // keep only digits
  if (digitsOnly.length >= 6 && digitsOnly.length <= 15) {
    // 6-15 digits in total (adjust the lower bound if needed)
    return true;
  }
  // If there are many short digit groups but combined digits >= 6:
  // (already covered by digitsOnly length)

  // 2) Normalize common obfuscations for email/link detection
  // Lowercase for easier matching
  let normalized = raw.toLowerCase();

  // convert common obfuscations to canonical forms:
  // - variants of " at " -> @
  // - variants of " dot " -> .
  // - remove surrounding spaces, [ ], ( ), - , _
  normalized = normalized
    // replace various [at] forms with @
    .replace(/\[\s*at\s*\]|\(\s*at\s*\)|\s+at\s+|\s+@+\s+/g, "@")
    // replace common "dot" obfuscations with '.'
    .replace(/\[\s*dot\s*\]|\(\s*dot\s*\)|\s+dot\s+|dotcom|dotorg|dotnet/g, ".")
    // collapse weird separators but keep @ and .
    .replace(/[\s\-_]+/g, "")
    // remove wrapping punctuation that can break detection
    .replace(/[<>"'`]/g, "");

  // 3) Email detection
  const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i;
  if (emailRegex.test(normalized)) return true;

  // 3b) If there's an '@' but no dot after it (e.g. abc@textcom),
  // treat as likely email if the part after @ is reasonably long
  const atIndex = normalized.indexOf("@");
  if (atIndex !== -1) {
    const domainPart = normalized.slice(atIndex + 1).replace(/[^a-z0-9]/g, "");
    if (domainPart.length >= 4) {
      // e.g. 'textcom' length 7 -> suspicious
      return true;
    }
  }

  // 4) URL detection (allow http(s) or common tlds even without protocol)
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|([a-z0-9-]+\.(com|in|net|org|io|co|me)\b)/i;
  if (urlRegex.test(normalized)) return true;

  // 5) Common words pattern: "call me", "whatsapp", "wa.me/", "telegram"
  const contactWords = /\b(call me|whatsapp|wa\.me|telegram|contact me|phone)\b/i;
  if (contactWords.test(raw)) return true;

  return false;
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};